import React from 'react';
import PropTypes from 'prop-types'

import css from './IconButton.module.scss'

const IconButton = ({ clickHandler, disabled, children}) => {
  const disabledCss = disabled ? css.disabled : null
  return (
    <button className={`${css.buttonCss} ${disabledCss}`} onClick={clickHandler} disabled={disabled}>
      {children}
    </button>
  )
}

IconButton.propTypes = {
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.any.isRequired
}

IconButton.defaultProps = {
  clickHandler: Function.prototype,
  disabled: false
}

export default IconButton;
